import { render, staticRenderFns } from "./SmallItinerarySidebar.vue?vue&type=template&id=52f8ea99&"
import script from "./SmallItinerarySidebar.vue?vue&type=script&lang=js&"
export * from "./SmallItinerarySidebar.vue?vue&type=script&lang=js&"
import style0 from "./SmallItinerarySidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports